export const locale = {
    lang: "en",
    data: {
        TAB: {
            Status: "Status",
            Data: "Data",
            Alarms: "Alarms",
            Events: "Events",
            Info: "Info",
            Report: "Report",
            Files: "Files",
        },
        DEVICES: {
            ID: "ID",
            Name: "Name",
            Active: "Active",
            LastData: "Last Data",
            Address: "Address",
            Devices: "Devices",
        },
        DEVICE: {
            NoiseLevel: "Noise Level",
            Limit: "Limit:",
            Info: "Info",
            Name: "Name",
            SerialNumber: "Serial Number",
            Location: "Location",
            Latitude: "Latitude",
            Longitude: "Longitude",
            NoGPSData: "No valid GPS data",
            Comments: "Comments",
            Last15Minutes: "Last 15 Minutes",
            LastHour: "Last Hour",
            Last4Hours: "Last 4 Hours",
            Last12Hours: "Last 12 Hours",
            Last24Hours: "Last 24 Hours",
            StartDate: "Start Date",
            EndDate: "End Date",
            Data: "Data",
            DateRange: "Date Range",
            DataAggregation: "Averaging",
            NoAggregation: "No Averaging",
            Minutes5: "5 Minutes",
            LiveUpdate: "Live Update",
            ShowL10: "Show L10",
            ShowL90: "Show L90",
            Custom: "Custom",
            Download: "Download CSV Data",
            StartTime: "Start Time",
            EndTime: "End Time",
            Image: "Image",
            DropFiles: "Drop Image Here",
            RemoveImage: "Remove Image",
            Picture: "Picture",
            SimOrImei: "SIM or IMEI",
            LastCalibrationDate: "Last Calibration Date",
            BaseName: "Device",
            LF010PeriodLimits: "LF010 Limits",
            LF010PeriodLimitsHelp: "Stored emission limits and mapped project periods.",
            LF010DevicePeriod: "LF010 period",
            LF010Limit: "Limit",
            LF010SectionTitle: "Limits",
            LF010SectionHelp: "Current LF010 period limits and the recorded change history.",
            LF010LimitHistory: "Limit History",
            LF010LimitHistoryHelp: "Previous LF010 limit changes received from the device.",
            LF010LimitHistoryEmpty: "No LF010 limit changes have been recorded yet.",
            LF010PreviousLimit: "Previous limit",
            LF010NewLimit: "New limit",
            LF010ChangedAt: "Changed at",
            ProjectPeriod: "Project period",
            NotMapped: "Not mapped",
            UploadFile: "Upload File",
            Minutes30: "30 Minutes",
            ShowSpectrum: "Show Spectrum",
        },
        ALARM: {
            ID: "Id",
            Name: "Name",
            Description: "Description",
            TimeWindow: "Time Window",
            Threshold: "Threshold",
            Limit: "Limit",
            LimitMode: "Limit mode",
            LimitModeWholeDay: "Whole day",
            LimitModePeriods: "By periods",
            Severity: "Severity",
            Field: "Field",
            Remove: "Remove",
            Duplicate: "Duplicate",
            time_window_instant: "Instant",
            time_window_bucket_5: "5 minutes bucket",
            threshold_cross_over: "Cross OVER",
            threshold_cross_below: "Cross BELOW",
            ADD: "ADD",
            SAVE: "SAVE",
            CANCEL: "CANCEL",
            AlarmDetail: "Alarm Detail",
            NewAlarm: "New Alarm",
            Notify: "Notify",
            Notification: "Notification",
            Silent: "Silent",
            NeedACK: "Need ACK",
            IgnoredDevices: "Ignored Devices",
            NewNotificationItem: "email/phone",
            NewNotificationItemEmailOnly: "email",
            NotificationChannels: "Notification channels",
            NotificationChannelsEmpty: "No project notification channels are available yet. Create them in the project admin view.",
            LegacyNotificationList: "Legacy recipients kept for compatibility",
            ProjectAlarm: "Project Alarms",
            AlarmDeleteTitle: "Alert",
            AlarmDeleteMessage: "This alarm has {{activeEvents}} active events. \nAre you sure you want to delete it?",
        },
        SEVERITY: {
            alarm: "Alarm",
            info: "Information",
            success: "Success",
            warning: "Warning",
        },
        FIELD: {
            sound_pressure_level: "Sound Pressure (dBA)",
            sound_pressure_level_c: "Sound Pressure (dBC)",
            sound_pressure_level_1m: "Sound Pressure (dBA, 1 min)",
            sound_pressure_level_1m_sensor_2: "Sound Pressure (Sensor 2)",
            sound_pressure_level_c_1m: "Sound Pressure (dBC, 1 min)",
            sound_pressure_level_c_minus_a: "dBC - dBA",
            rolling_5s: "Rolling 5 seconds (dBA)",
            rolling_5s_c: "Rolling 5 seconds (dBC)",
            rolling_5: "Rolling 5 minutes (dBA)",
            rolling_5_c: "Rolling 5 minutes (dBC)",
            rolling_30: "Rolling 30 minutes (dBA)",
            rolling_30_c: "Rolling 30 minutes (dBC)",
            battery: "Battery",
            power_supply_status: "Power Supply",
            spectrum_13_octave: "1/3 Octave Spectrum",
            temperature: "Ext. Temperature",
            overload: "Overload",
            underrange: "Underrange",
            spectrum_13_octave_1m: "1/3 Octave Spectrum (1 min)",
            wifi_signal_level: "WiFi Signal",
            cellullar_signal_level: "Cellular Signal",
            free_storage: "Free Storage",
        },
        REPORT: {
            General: "General Data",
            Device: "Device / Serial Number",
            Address: "Address",
            Comments: "Comments",
            Register: "Register",
            GenerateReport: "Generate Report",
            Dates: "Dates",
            GPS: "GPS Coordinates",
            Photo: "Photo",
            ProjectName: "Project Name",
            RegisteredParameters: "Registered Parameters",
            Graph: "Graph",
            Observations: "Observations",
            CustomAlarm: "Custom Limit",
            Limits: "Limits",
            Fields: "Fields",
            Map: "Map",
            DataSetup: "Data Setup",
            ReportOptions: "Report Options",
            Options: "Options",
            Interval: "Interval",
            AWeighting: "A",
            CWeighting: "C",
            Color: "Color",
            LineStyle: "Line",
            Interval1s: "1s",
            Interval5sRolling: "5s rolling",
            Interval5minBucket: "5min (bucket)",
            Interval5minRolling: "5min rolling max",
            Interval30minRolling: "30min rolling max",
            LineStyleSolid: "Solid",
            LineStyleDashed: "Dashed",
            LineStyleDotted: "Dotted",
            DeviceComments: "Device Comments",
            PeriodBands: "Show period bands",
            LAeq1s: "LAeq 1s",
            LCeq1s: "LCeq 1s",
            LAeq5sRolling: "LAeq 5s rolling",
            LCeq5sRolling: "LCeq 5s rolling",
            LAeq5minBucket: "LAeq 5min (bucket)",
            LCeq5minBucket: "LCeq 5min (bucket)",
            LAeq5minRolling: "LAeq 5min rolling (max)",
            LCeq5minRolling: "LCeq 5min rolling (max)",
            LAeq30minRolling: "LAeq 30min rolling (max)",
            LCeq30minRolling: "LCeq 30min rolling (max)",
            LAqe30: "LAeq 30min",
            LAqe5: "LAeq 5min",
            LAqe1: "LAeq 1sec",
            LAqe5s: "LAeq 5sec",
            YAxisRange: "Y-axis Range",
            YAxisMin: "Minimum",
            YAxisMax: "Maximum",
        },
        FILE: {
            Name: "Name",
            UploadDate: "Upload Date",
            Status: "Status",
            DropFile: "Drop File Here",
            uploaded: "Uploaded",
            processing: "Processing",
            processed: "Processed",
        },
    },
};
